"use client";
import Image from "next/image";
import Head from "next/head";
import { getBlogPosts } from "../../app/blogData"; 
import { getArticleCoverAlt } from "@/lib/blogImagePresentation.mjs";

const BlogPostAutomations = ({ locale, id }: { locale: string, id: string }) => {
    // Obtener los posts según el idioma
    const posts = getBlogPosts(locale);
    const post = posts.find((p) => p.id === id);  // ✅ Buscar post por ID

    if (!post) return <p className="text-center text-body text-gray-600">Artículo no encontrado.</p>;

    return (
        <>
            <Head>
                <title>{post.title}</title>
            </Head>
            <main className="flex justify-center items-center px-4 py-8">
                <div className="w-full text-center">
                    <h1 className="mb-4 text-section font-bold">{post.title}</h1>
                    <p className="mb-4 text-body text-gray-600">{post.excerpt}</p>
                    
                    {post.coverImage && (
                        <div className="w-full max-w-[1288px] h-[500px] mx-auto">
                            <Image
                                src={post.coverImage}
                                alt={getArticleCoverAlt(undefined, locale)}
                                width={1288}
                                height={500}
                                priority
                                className="h-full w-full object-cover object-center rounded-xl shadow-lg"
                                decoding="async"
                            />
                        </div>
                    )}

                    <article
                        className="prose lg:prose-xl max-w-5xl mx-0 px-10 md:px-10 lg:px-20 text-left leading-loose"
                        dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                </div>
            </main>
        </>
    );
};

export default BlogPostAutomations;
